import animations from 'Assets/js/modules/animations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';

export default function heroCocktailRecipe(options = {}) {
  try {
    const { block } = options;
    jsUtils.loadCss(block.dataset.assetkey, options).then(() => {
      if (block.dataset.colour_filter !== 'none') {
        // Set CSS variable
        document.body.style.setProperty(
          '--hero-cocktail-recipe-opacity',
          +block.dataset.colour_filter_opacity / 100
        );
      }
      animations.fadeIn(block);
      // Add your Javascript code here...
    });
  } catch (error) {
    console.error(error);
  }
}
